import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import isMobileView from '../../util/MobileView'
import { ApplicationViewPortDesktop } from './ApplicationViewPortDesktop'
import { ApplicationViewPortMobile } from './ApplicationViewPortMobile'

export function ApplicationViewPort(props) {
  const isMobile = isMobileView()
  const { t } = useTranslation()

  return isMobile ? (
    <ApplicationViewPortMobile
      applications={props.applications}
      noAppsMsg={props.noAppsMsg}
      errorContactMsg={props.errorContactMsg}
      onClick={props.onClick}
      buttonLinkText={t('open-label-text')}
      isGridView={props.isGridView}
    />
  ) : (
    <ApplicationViewPortDesktop
      applications={props.applications}
      noAppsMsg={props.noAppsMsg}
      errorContactMsg={props.errorContactMsg}
      onClick={props.onClick}
      buttonLinkText={t('open-label-text')}
      favoriteLabelText={t('favorite-label-text')}
      isGridView={props.isGridView}
    />
  )
}

ApplicationViewPort.propTypes = {
  applications: PropTypes.arrayOf(PropTypes.shape({
    appId: PropTypes.string,
    src: PropTypes.string,
    link: PropTypes.string,
    label: PropTypes.string.isRequired,
  })),
  noAppsMsg: PropTypes.string,
  errorContactMsg: PropTypes.string,
  onClick: PropTypes.func,
  isGridView: PropTypes.bool,
}

ApplicationViewPort.defaultProps = {
  applications: [],
  noAppsMsg: 'NoAppsMsg',
  errorContactMsg: 'ErrorContactMsg',
  onClick: (link) => {
    window.open(link, '_blank')
  },
  isGridView: true,
}
